import { openDB } from 'idb';

const DB_NAME = 'PromptCacheDB';
const DB_VERSION = 1;
const STORE_NAMES = {
    CATEGORIES: 'categories',
    PROMPTS: 'prompts',
};

// Global reference to the DB instance
let dbInstance = null;

// Initialize and cache DB connection
export const initDB = async () => {
    if (!dbInstance) {
        dbInstance = await openDB(DB_NAME, DB_VERSION, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(STORE_NAMES.CATEGORIES)) {
                    db.createObjectStore(STORE_NAMES.CATEGORIES);
                }
                if (!db.objectStoreNames.contains(STORE_NAMES.PROMPTS)) {
                    db.createObjectStore(STORE_NAMES.PROMPTS);
                }
            },
        });
    }
    return dbInstance;
};

// Close DB connection
export const closeDB = () => {
    if (dbInstance) {
        dbInstance.close();
        dbInstance = null;
    }
};

// Get item from a store
export const getFromDB = async (storeName, key) => {
    const db = await initDB();
    return db.get(storeName, key);
};

// Set item in a store
export const setToDB = async (storeName, key, value) => {
    const db = await initDB();
    return db.put(storeName, value, key);
};

// Clear/delete entire DB
export const clearIndexedDB = () => {
    return new Promise((resolve, reject) => {
        // Ensure connection is closed before deleting
        closeDB();

        const deleteRequest = indexedDB.deleteDatabase(DB_NAME);

        deleteRequest.onsuccess = () => {
            resolve();
        };

        deleteRequest.onerror = (event) => {
            reject(event);
        };

        deleteRequest.onblocked = () => {
        };
    });
};

export { STORE_NAMES };
